import React from 'react'
import "./index.css";
import loadingVdo from "../../../assets/img/animation-loader 2.webm"
function Loading() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: "10px 0",flexDirection:"column" }}>
<video autoPlay loop muted playsInline style={{width:"30%"}}>
  <source src={loadingVdo} type="video/webm" />
</video>
<span class="loader-txt"></span>        {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: "100px" }}>
        <span className="loader"></span>
    </div> */}
    </div>
    
  )
}

export default Loading;